import BreadCrumb from "Components/Common/BreadCrumb";
import "react-toastify/dist/ReactToastify.css";
import { Card, Container, Table } from "reactstrap";
import "./EcommerceOrderDetail.scss";
import timer from "../../assets/images/timer.svg";
import orderImg from "../../assets/images/orderProduct.png";
import minus from "../../assets/images/Minus.svg";
import plus from "../../assets/images/Plus.svg";
import profile from "../../assets/images/userProfile.png";
import locations from "../../assets/images/location.svg";
import money from "../../assets/images/moneys.svg";
import { useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOrderDetail,
  updateOrder,
  updateOrderTime,
} from "live-slices/eCommerceOrder/thunk";
import {
  updateOrderQuantityApi,
  updateProductAvailabiltyApi,
} from "live-slices/eCommerceOrder/thunk";
import { createSelector } from "reselect";
import { toast, ToastContainer } from "react-toastify";
import ReasonModal from "./components/ReasonModal";
import ConfirmOrderModal from "./components/ConfirmOrderModal";
import FindModal from "./components/FindModal";
import VideoViewer from "Components/Common/VideoViewer";
import { Constant } from "utils/enums";

const MyEcommerceOrderDetail = (props: any) => {
  document.title = "Orders | BuyPass";
  const location = useLocation();
  const params = useParams();
  const dispatch: any = useDispatch();
  const orderId =
    location.state?.orderId ||
    params.id ||
    new URLSearchParams(location.search).get("orderId");

  const selecteOrderDetailData = createSelector(
    (state: any) => state.Orders,
    (orderDetail) => orderDetail?.orderDetail
  );
  const [currentImage, setCurrentImage] = useState("");
  const orderInfo = useSelector(selecteOrderDetailData);
  const [orderDetail, setorderDetail] = useState<any>({});
  const [reasonModal, setReasonModal] = useState(false);
  const [acceptLoading, setAcceptLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [selectedReason, setSelectedReason] = useState("");
  const [selectedOrderId, setSelectedOrderId] = useState<string | null>(null);
  const [isViewerOpen, setViewerOpen] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [findModal, setfindModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any | null>(null);
  const [selectedAvailableReason, setAvailableReason] = useState<string>("");
  const businessType: any = localStorage.getItem(Constant.seller)
  const type = JSON.parse(businessType)
  useEffect(() => {
    dispatch(fetchOrderDetail(orderId));
  }, [orderId]);

  const onClickOrderStatus = async (
    orderId: string,
    status: string,
    setButtonLoading: React.Dispatch<React.SetStateAction<boolean>>,
    sellerCancellationReason?: string
  ) => {
    setButtonLoading(true);
    try {
      dispatch(updateOrderTime({ orderId, status, sellerCancellationReason }));
      await new Promise((resolve) => setTimeout(resolve, 2000));
      const updatedOrder = await dispatch(fetchOrderDetail(orderId));
      toast.success("Status Updated.", { autoClose: 1000 });
      setorderDetail(updatedOrder?.payload);
      setButtonLoading(false);
    } catch (error) {
      setButtonLoading(false);
      toast.error("Status Failed.", { autoClose: 1000 });
      console.error("Error updating order status:", error);
    } finally {
      setButtonLoading(false);
    }
  };

  const onClickOrderTimingChange = async (
    orderId: string,
    status: string,
    setButtonLoading: React.Dispatch<React.SetStateAction<boolean>>,
    preparingTime?: any
  ) => {
    setButtonLoading(true);
    try {
      dispatch(updateOrderTime({ orderId, status, preparingTime }));
      await new Promise((resolve) => setTimeout(resolve, 2000));
      const updatedOrder = await dispatch(fetchOrderDetail(orderId));
      toast.success("Status Updated.", { autoClose: 1000 });
      setorderDetail(updatedOrder?.payload);
      setButtonLoading(false);
    } catch (error) {
      setButtonLoading(false);
      toast.error("Status Failed.", { autoClose: 1000 });
      console.error("Error updating order status:", error);
    } finally {
      setButtonLoading(false);
    }
  };

  const handleAcceptClick = (orderId: string) => {
    setSelectedOrderId(orderId);
    setConfirmModal(true);
  };

  const handleToggleChange = (e: any, item: any) => {
    if (e.target.checked) {
      dispatch(
        updateProductAvailabiltyApi({
          orderId: orderInfo._id,
          productId: item.productId,
          sellerCancellationReason: "",
        })
      );
    } else {
      setSelectedItem(item);
      setfindModal(true);
    }
  };

  const handleConfirmOrder = async (selectedTime: string) => {
    if (selectedOrderId) {
      await onClickOrderTimingChange(
        selectedOrderId,
        "orderAccepted",
        setAcceptLoading,
        selectedTime
      );
    }
    setConfirmModal(false);
  };

  const handleReasonSubmit = () => {
    if (!selectedReason) {
      alert("Please select a reason for rejection.");
      return;
    }
    onClickOrderStatus(
      orderInfo._id,
      "cancelledBySeller",
      setRejectLoading,
      selectedReason
    );
    setReasonModal(false);
    setSelectedReason("");
  };

  const handleRejectClick = () => {
    setReasonModal(true);
  };

  var [timeLeft, setTimeLeft] = useState<number | null>(null);

  useEffect(() => {
    setTimeLeft(calculateTimeLeft());
  }, [orderInfo?.preparingTime, orderInfo?.orderAcceptTime]);

  const calculateTimeLeft = () => {
    if (orderInfo?.preparingTime === 0 && orderInfo?.status === "orderPlaced") {
      const now = Date.now();
      const diff = Math.max(orderInfo?.orderAcceptTime - now, 0);
      return Math.floor(diff / 1000);
    } else {
      const now = Date.now();
      const diff = Math.max(orderInfo?.preparingTime - now, 0);
      return Math.floor(diff / 1000);
    }
  };

  useEffect(() => {
    if (timeLeft === null || timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
      2,
      "0"
    )}`;
  };

  const handleDecreaseQuantity = async (order: any, productId: any) => {
    if (order > 1) {
      const updatedOrder = {
        orderId: orderInfo._id,
        productId: productId,
        quantity: order - 1,
      };

      try {
        const response = await dispatch(updateOrderQuantityApi(updatedOrder));
        if (response) {
          dispatch(fetchOrderDetail(orderId));
        }
      } catch (error) {
        console.error("API Error:", error);
        toast.error("Failed to update quantity!", { autoClose: 1000 });
      }
    } else {
      toast.error("Quantity cannot be less than 1", { autoClose: 1000 });
    }
  };

  const handleSubmit = () => {
    if (!selectedItem || !selectedAvailableReason) return;
    dispatch(
      updateProductAvailabiltyApi({
        orderId: orderInfo._id,
        productId: selectedItem.productId,
        reason: selectedAvailableReason,
      })
    )
      .then(() => {
        dispatch(fetchOrderDetail(orderId));
      })
      .catch((error: any) => {
        toast.error(error, { autoClose: 1000 });
      });

    setfindModal(false);
    setSelectedReason("");
  };
  const openViewer = (videoUrl: string) => {
    setCurrentImage(videoUrl);
    setViewerOpen(true);
  };
  const closeViewer = () => {
    setViewerOpen(false);
  };

  const handleIncreaseQuantity = async (order: number, productId: any, maxQuantity: number) => {
    if (order >= maxQuantity) {
      toast.error(`Maximum quantity limit reached (${maxQuantity})`, { autoClose: 1000 });
      return;
    }
    const updatedOrder = {
      orderId: orderInfo._id,
      productId: productId,
      quantity: order + 1,
    };

    try {
      const response = await dispatch(updateOrderQuantityApi(updatedOrder));
      if (response) {
        dispatch(fetchOrderDetail(orderInfo._id));
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Failed to update quantity!", { autoClose: 1000 });
    }
  };

  const formatStatus = (status: any) => {
    if (!status) return "Unknown Status";

    return status
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str: any) => str.toUpperCase());
  };

  const formattedStatus = formatStatus(orderInfo?.status);


  return (
    <div className="page-content orderDetailMainPage">
      <ToastContainer />
      <Container fluid>
        <BreadCrumb
          title="Order Details"
          pageTitle="Orders"
          pageTitleRoute="/ecommerce-orders"
        />
        <ReasonModal
          show={reasonModal}
          onCloseClick={() => setReasonModal(false)}
          onSubmit={handleReasonSubmit}
          selectedReason={selectedReason}
          setSelectedReason={setSelectedReason}
        />
        <VideoViewer
          isOpen={isViewerOpen}
          videoUrl={currentImage}
          toggle={closeViewer}
        />
        <FindModal
          show={findModal}
          onCloseClick={() => setfindModal(false)}
          onSubmit={handleSubmit}
          selectedAvailableReason={selectedAvailableReason}
          setAvailableReason={setAvailableReason}
        />
        <ConfirmOrderModal
          show={confirmModal}
          onCloseClick={setConfirmModal}
          onConfirm={handleConfirmOrder}
          orderDetail={orderInfo}
        />
        <div className="mainLayoutOrderDetail">
          <div className="tableDataCol">
            <Card className="topCArd">
              <div className="orderDetailRow">
                <div className="orderId">
                  <h3>🛒 #{orderInfo?.buypassId}</h3>
                  <div className="thisOrder">
                    {/* <p>This order is </p> */}
                    <div className="status-main d-flex">
                      <div className="statusDv me-3">
                        <div className="dot"></div>
                        <p style={{ textTransform: "capitalize" }}>
                          {formattedStatus}
                        </p>
                      </div>
                      {/* <div className="thisOrder">
                    <div className="statusDv" style={{ background: "#FF4F4F" }}>
                      <p className="text-white" style={{ textTransform: "capitalize" }}>
                        SLA Breached
                      </p>
                    </div>
                  </div> */}
                      {orderInfo?.status === "orderPlaced" &&
                        timeLeft === 0 &&
                        new Date() >= new Date(orderInfo?.slaBrechedTiming) && (
                          <div
                            style={{ background: "#FF4F4F" }}
                            className={`statusDv me-3 ${timeLeft === 0 ? "expired" : ""}`}
                          >
                            <p className="text-white" style={{ textTransform: "capitalize" }}>
                              SLA Breached
                            </p>
                          </div>
                        )}


                    </div>
                  </div>
                </div>
                <div className="orderStutes">
                  {/* {timeLeft !== 0 && (
                    <div className="timingDv">
                      <img src={timer} alt="" />
                      <h4>
                        {formatTime(timeLeft ? timeLeft : 0)} <span>left</span>
                      </h4>
                    </div>
                  )} */}
                  {orderInfo?.status === "cancelledBySeller" ||
                    (orderInfo?.status === "cancelledBySeller" && (
                      <>
                        <button
                          type="button"
                          className="btn btn-secondary acceptBtn"
                          data-testing-id="acceptButton"
                          disabled={orderInfo?.items?.every((item: { isAvailable: boolean }) => !item.isAvailable)}
                          onClick={() => handleAcceptClick(orderInfo._id)}
                        >
                          Accept
                        </button>
                        <button
                          type="button"
                          className="btn  rejectBtn"
                          data-testing-id="rejectButton"
                          onClick={handleRejectClick}
                        >
                          Reject
                        </button>

                      </>
                    ))}
                  {orderInfo?.status === "orderAccepted" ||
                    orderInfo?.status === "pending" ||
                    (orderInfo?.status === "orderPlaced" && (
                      <>
                        <button
                          type="button"
                          className="btn btn-secondary acceptBtn"
                          data-testing-id="acceptButton"
                          onClick={() => handleAcceptClick(orderInfo._id)}
                          disabled={orderInfo?.items?.every((item: { isAvailable: boolean }) => !item.isAvailable)}
                        >
                          Accept
                        </button>
                        <button
                          type="button"
                          data-testing-id="rejectButton"
                          className="btn  rejectBtn"
                          onClick={handleRejectClick}
                        >
                          Reject
                        </button>

                      </>
                    ))}
                </div>
              </div>
              <div className="tableDv">
                <Table>
                  <thead>
                    <tr>
                      <th>Image</th>
                      <th>Product Name</th>
                      <th>Variants</th>
                      <th>SKU</th>
                      <th>Quantity</th>
                      <th>Unit Price</th>
                      <th>Subtotal</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderInfo?.items?.map((item: any, index: number) => (
                      <tr key={index}
                        className={`${!item.isAvailable ? "RedColourProduct" : ""}`}
                      >
                        <td>
                          <img
                            src={item.productImage}
                            className="productImage"
                            alt=""
                          />
                        </td>
                        <td>
                          <h4 className="product-name">{item.productName}</h4>
                        </td>
                        <td>
                          <h4>
                            {item.variants
                              .map((variant: any) => `${variant.value.name}`)
                              .join(", ")}
                          </h4>
                        </td>
                        <td>
                          <h4 className="product-name">{item.sku}</h4>
                        </td>
                        <td>
                          <div className="quantityDv">
                            <button
                              onClick={() =>
                                handleDecreaseQuantity(
                                  item.quantity,
                                  item.productId
                                )
                              }
                              disabled={orderInfo.status !== "orderPlaced"}
                              style={{
                                background: "none",
                                border: "none",
                                padding: "0px",
                              }}
                            >

                              <i className='bx bx-minus plusDVV' style={{
                                backgroundColor:
                                  item.quantity <= 1
                                    ? "#83bbff"
                                    : orderInfo.status !== "orderPlaced"
                                      ? "#83bbff"
                                      : "#0877FF",
                                padding: "1px",
                                borderRadius: "4px",
                              }}></i>
                            </button>
                            <h3>{item.quantity}</h3>
                            <button
                              onClick={() => handleIncreaseQuantity(item.quantity, item.productId, item.ordignalQuantity)}
                              disabled={orderInfo.status !== "orderPlaced"}
                              style={{
                                background: "none",
                                border: "none",
                                padding: "0px",
                              }}
                            >
                              <i className='bx bx-plus plusDVV' style={{
                                backgroundColor:
                                  item.quantity >= item.ordignalQuantity
                                    ? "#83bbff"
                                    : orderInfo.status !== "orderPlaced"
                                      ? "#83bbff"
                                      : "#0877FF",
                                padding: "1px",
                                borderRadius: "4px",
                              }}></i>
                            </button>
                          </div>
                        </td>
                        <td>
                          <h4>
                            Rs{" "}
                            {Number.isFinite(item?.individualSummary?.productPrice)
                              ? Math.ceil(item.individualSummary.productPrice)
                              : "0"}
                          </h4>
                        </td>

                        <td>
                          <h4>
                            Rs{" "}
                            {Number.isFinite(item?.overallItemSummary?.productPrice)
                              ? Math.ceil(item.overallItemSummary.productPrice)
                              : "0"}
                          </h4>
                        </td>

                        <td>
                          <div className="toggleDv">
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                data-testing-id="toggleActive"
                                type="checkbox"
                                checked={item.isAvailable}
                                onChange={(e) => handleToggleChange(e, item)}
                                disabled={orderInfo.status !== "orderPlaced"}
                              />
                              <label className="p-0 m-0 ms-2 toggleLabel">
                                {item.isAvailable
                                  ? "Available"
                                  : item.productUnavailablityReason}
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Card>
            <Card className="bottomCArd">
              <div className="bottomData">
                {orderInfo?.sellerCancellationReason && (
                  <div className="rowData">
                    <p>Cancellation Reason:</p>
                    <div className="lastDv">
                      <p>
                        {Number.isFinite(orderInfo?.sellerCancellationReason)
                          ? Math.ceil(orderInfo.sellerCancellationReason).toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                          : orderInfo?.sellerCancellationReason || "N/A"}
                      </p>

                    </div>

                  </div>
                )}
                {orderInfo?.cancellationReason && (
                  <div className="rowData">
                    <p>Cancellation Reason:</p>
                    <div className="lastDv">
                      <p>
                        {Number.isFinite(orderInfo?.cancellationReason)
                          ? Math.ceil(orderInfo.cancellationReason).toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                          : orderInfo?.cancellationReason || "N/A"}
                      </p>


                    </div>

                  </div>
                )}


                {/* <div className="rowData">
                                    <p>Adjust Amount:</p>
                                    <div className='lastDv'>
                                        <p>Rs 4199.00</p>
                                    </div>
                                </div> */}
                {/* <div className="rowData">
                  <p>Shipping Charges:</p>
                  <div className="lastDv">
                    <p>Rs {orderInfo?.orderSummary?.shippingfee.toLocaleString("en-US", { 
                          minimumFractionDigits: 2, 
                          maximumFractionDigits: 2 }) || 0}</p>
                  </div>
                </div> */}
                {/* <div className="rowData">
                  <p>Vat:</p>
                  <div className="lastDv">
                    <p>Rs {orderInfo?.orderSummary?.vat}</p>
                  </div>
                </div> */}
                {/* <div className="rowData">
                  <p>Adjust Amount:</p>
                  <div className="lastDv">
                    <p>Rs {orderInfo?.orderSummary?.adjustmentPrice || 0}</p>
                  </div>
                </div> */}


                {/* <div className="rowData">
                  <p>
                    Discount <span className=" text-secondary">(Buypass):</span>
                  </p>
                  <div className="lastDv">
                    <p>Rs {orderInfo?.orderSummary?.discount}</p>
                  </div>
                </div> */}
                {orderInfo?.orderSummary?.total === 0 ? ("") : (
                  <div className="rowData">
                    <p>Total:</p>
                    <div className="lastDv">
                      <p>
                        Rs{" "}
                        {Number.isFinite(orderInfo?.orderSummary?.total)
                          ? Math.ceil(orderInfo.orderSummary.total)
                          : "N/A"}
                      </p>

                    </div>
                  </div>
                )}
                {orderInfo?.orderSummary?.subTotal === 0 ? ("") : (
                  <div className="rowData">
                    <p>Sub total:</p>
                    <div className="lastDv">
                      <p>
                        Rs{" "}
                        {Number.isFinite(orderInfo?.orderSummary?.subTotal)
                          ? Math.ceil(orderInfo.orderSummary.subTotal)
                          : "N/A"}
                      </p>

                    </div>
                  </div>
                )}

                {[
                  { label: "Adjustment Fee", key: "adjustmentPrice" },
                  { label: "Buypass Profit", key: "buypassProfit" },
                  { label: "BP Commission", key: "commission" },
                  { label: "Cash Handling Fee", key: "cashHandlingFee" },
                  { label: "Package Handling Fee", key: "packageHandling" },
                  { label: "Tax Fee", key: "tax" },
                  { label: "Shipping Fee", key: "shippingfee" },
                  { label: "VAT", key: "vat" },
                ].map((item) => {
                  const value = orderInfo?.orderSummary?.[item.key];
                  const isNumber = typeof value === "number";

                  return (
                    value === 0 ? ("") : (
                      <div className="rowData" key={item.key}>
                        <p>{item.label}:</p>
                        <div className="lastDv">
                          <p>
                            {isNumber
                              ? value === 0
                                ? "Rs 0"
                                : "Rs - " + Math.ceil(value)
                              : ""}
                          </p>

                        </div>
                      </div>
                    )
                  );
                })}
                {orderInfo?.orderSummary?.sellerPrice === 0 ? ("") : (
                  <div className="rowData">
                    <h3>Grand Total</h3>
                    <div className="lastDv">
                      <h3>
                        Rs{" "}
                        {Number.isFinite(orderInfo?.orderSummary?.sellerPrice)
                          ? Math.ceil(orderInfo.orderSummary.sellerPrice)
                          : Number.isFinite(orderInfo?.orderSummary?.total)
                            ? Math.ceil(orderInfo.orderSummary.total)
                            : "0"}
                      </h3>

                    </div>
                  </div>
                )}


                {/* <div className="rowData">
                  <p>Penalty:</p>
                  <div className="lastDv">
                    <p>Rs {orderInfo?.orderSummary?.penalty.toLocaleString("en-IN")}</p>
                  </div>
                </div>
                <div className="rowData">
                  <p>Returns:</p>
                  <div className="lastDv">
                    <p>Rs {orderInfo?.orderSummary?.returns.toLocaleString("en-IN")}</p>
                  </div>
                </div> */}
                {/* <div className="rowData">
                  <p>Total Deduction:</p>
                  <div className="lastDv">
                    <p>Rs {orderInfo?.orderSummary?.otherDeduction.toLocaleString("en-IN")}</p>
                  </div>
                </div> */}

                {/* <div className="rowData">
                  <p >Buypass Commission</p>
                  <div className="lastDv">
                    <p >- Rs
                      {`${orderInfo?.orderSummary?.buypassCommission || 0}`}</p>
                  </div>
                </div> */}
                {/* <div className="rowData">
                  <h6 className="finalCom">Final Amount</h6>
                  <div className="lastDv">
                  <h6 className="finalCom">
                      Rs{" "}
                      {orderInfo?.orderSummary?.total &&
                        orderInfo?.orderSummary?.buypassCommission
                        ? (
                          orderInfo?.orderSummary?.total - orderInfo?.orderSummary?.buypassCommission
                        )
                          .toLocaleString("en-IN")
                          .replace(/\.00$/, "")
                        : "0"}
                    </h6>
                  </div>
                </div> */}
              </div>
            </Card>
          </div>
          <div className="custemerDetailCol">
            {/* <Card>
              <div className="heading">
                <h5>Customer Details</h5>
              </div>
              <div className="bodyDv">
                <div className="profileDv">
                  <img src={profile} alt="" />
                  <div className="content">
                    <h5>{orderInfo?.userDetails?.name}</h5>
                    <p>Customer</p>
                  </div>
                </div>
              </div>
            </Card> */}
            {/* <Card className="cardDv">
              <div className="heading">
                <img src={locations} alt="" />
                <h5>Billing Address</h5>
              </div>
              <div className="bodyDv">
                <div className="profileDv">
                  <div className="content">
                    <h5>{orderInfo?.userDetails?.name}</h5>
                    <p>
                      {orderInfo?.address?.streetAddress},
                      {orderInfo?.address?.state},{orderInfo?.address?.city}
                    </p>
                  </div>
                </div>
              </div>
            </Card> */}
            {/* <Card className='cardDv'>
                            <div className='heading'>
                                <img src={locations} alt="" />
                                <h5>Customer Details</h5>
                            </div>
                            <div className='bodyDv'>
                                <div className="profileDv">
                                    <div className='content'>
                                        <h5>Adeel</h5>
                                        <p>1234 Elm Street, Apt 567Los Angeles, CA 90001United States</p>
                                    </div>
                                </div>
                            </div>
                        </Card> */}
            {/* <Card className="cardDv">
              <div className="heading">
                <img src={money} alt="" />
                <h5>Customer Details</h5>
              </div>
              <div className="bodyDv">
                <div className="profileDv">
                  <div className="contentTow">
                    <div className="contentRow">
                      <h5>Payment Method:</h5>
                      <p> {orderInfo?.paymentMethodData?.name} </p>
                    </div>
                    <div className="contentRow">
                      <h5>Description:</h5>
                      <h6>{orderInfo?.paymentMethodData?.description} </h6>
                    </div>
                  </div>
                </div>
              </div>
            </Card> */}
              <Card className="cardDv">
                          <div className="heading">
                            <img src={money} alt="" />
                            <h5>Shipping Details</h5>
                          </div>
                          <div className="bodyDv">
                            <div className="profileDv">
                              <div className="contentTow">
                                 <div className="profileDv">
                              <img src={orderInfo?.userDetails?.profilePicture?.url || profile} alt="" />
                              <div className="content">
                                <h5>{orderInfo?.userDetails?.name}</h5>
                                <p>Customer</p>
                              </div>
                            </div>
                                <div className="contentRow">
                                  <p>Phone No:</p>
                                  <h5 style={{marginTop:"2px",textTransform:"capitalize"}}> {orderInfo?.address?.phoneNumber} </h5>
                                </div>
                                           <div className="contentRow" style={{ display: 'flex', alignItems: 'flex-start' }}>
  <p style={{ minWidth: '25px', margin: 0 }}>Address:</p>
 <h5
  style={{
    margin: 0,
    textTransform: 'capitalize',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    flex: 1,marginTop:"2px"
  }}
>
  {[
    orderInfo?.address?.streetAddress,
    orderInfo?.address?.area,
    orderInfo?.address?.neighbourhood,
    orderInfo?.address?.city,
    orderInfo?.address?.state,
  ]
    .filter(Boolean)
    .join(', ')}
</h5>

</div>
                                <div className="contentRow">
                                  <p>Payment Method:</p>
                                  <h5 style={{marginTop:"2px",textTransform:"capitalize"}}> {orderInfo?.paymentMethodData?.name} </h5>
                                </div>
                                   <div className="contentRow">
                                  <p>Total:</p>
                                  <h5 style={{marginTop:"2px",textTransform:"capitalize"}}>
                                      Rs{" "}
                        {Number.isFinite(orderInfo?.orderSummary?.total)
                          ? Math.ceil(orderInfo.orderSummary.total)
                          : "N/A"}
                                  </h5>
                                </div>
                                {/* <div className="contentRow" style={{ flexWrap: 'nowrap' }}>
                                  <p style={{ width: '158px' }}>Description:</p>
                                  <h5 style={{ lineHeight: '1.4' }}>{orderInfo?.paymentMethodData?.description} </h5>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </Card>
            {orderInfo?.orderPackageImage?.length > 0 && (
              <Card className="cardDv videoCard">
                <div className="heading">
                  <h5>Video Proof</h5>
                </div>
                <div className="bodyDv scroll-body">
                  {orderInfo.orderPackageImage.map((item: any, index: any) => (
                    <video
                      key={index}
                      src={item?.url}
                      style={{ width: "100px", height: "73px", marginRight: "10px", cursor: "pointer" }}
                      onClick={() => openViewer(item?.url)}
                      controls
                    />
                  ))}
                </div>
              </Card>
            )}

          </div>
        </div>
      </Container>
    </div>
  );
};

export default MyEcommerceOrderDetail;